@if (loading()) {
  <div class="container-fluid py-6 text-center text-muted">A carregar…</div>
} @else if (error()) {
  <div class="container-fluid py-6 text-center text-danger">{{ error() }}</div>
} @else if (client(); as c) {
  <div class="container-fluid">
    <app-page-header
      icon="fe-user"
      [pretitle]="c.company || 'Cliente'"
      [title]="c.name"
      [description]="c.email"
    >
      <div actions class="d-flex align-items-center gap-2">
        <span class="badge" [class]="clientStatusBadge(c.status)">{{ clientStatusLabels[c.status] }}</span>
        <a class="btn btn-outline-light" [routerLink]="['..']">Voltar</a>
        @if (auth.can('client:write')) {
          <a class="btn btn-white" [routerLink]="['editar']"><i class="fe fe-edit-2 me-1"></i> Editar</a>
        }
      </div>
    </app-page-header>
  </div>

  <div class="container-fluid">
    <div class="row">
      <!-- Dados do cliente. Esteve aqui ao lado um cartão de "Chamados do cliente": era do
           módulo de atendimento, que não faz parte deste produto, e dizia sempre que o cliente
           não tinha aberto nenhum. -->
      <div class="col-12 col-lg-7">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-primary-soft text-primary"><i class="fe fe-user"></i></span></span>
              <h4 class="card-header-title mb-0">Dados</h4>
            </div>
          </div>
          <div class="card-body">
            <dl class="row small mb-0 gy-3">
              <dt class="col-4 text-muted">E-mail</dt>
              <dd class="col-8 mb-0">{{ c.email }}</dd>

              <dt class="col-4 text-muted">Telefone</dt>
              <dd class="col-8 mb-0">{{ c.phone || '—' }}</dd>

              <dt class="col-4 text-muted">Empresa</dt>
              <dd class="col-8 mb-0">{{ c.company || '—' }}</dd>

              <dt class="col-4 text-muted">Organização</dt>
              <dd class="col-8 mb-0">
                @if (c.organizationId) {
                  <a [routerLink]="['../../organizacoes', c.organizationId]">{{ c.organizationName }}</a>
                } @else {
                  —
                }
              </dd>

              <dt class="col-4 text-muted">Situação</dt>
              <dd class="col-8 mb-0">
                <span class="badge" [class]="clientStatusBadge(c.status)">{{ clientStatusLabels[c.status] }}</span>
              </dd>

              <dt class="col-4 text-muted">Registado</dt>
              <dd class="col-8 mb-0">{{ c.createdAt | date: 'dd/MM/yyyy' }}</dd>
            </dl>

            @if (c.notes) {
              <hr class="my-3" />
              <h6 class="text-uppercase text-muted mb-2">Notas</h6>
              <p class="mb-0" style="white-space: pre-wrap;">{{ c.notes }}</p>
            }
          </div>
        </div>
      </div>

    </div>
  </div>
}
